// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../reason/common/Theme/Theme__Color.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Colors = require("uikit/styles/colors");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationMessageFiles_conversationMessage_graphql = require("../../__generated__/ConversationMessageFiles_conversationMessage_graphql.bs.js");

var convertFragment = ConversationMessageFiles_conversationMessage_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationMessageFiles_conversationMessage_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__MessageFiles$WithoutErrorBoundary(props) {
  var match = use(props.message);
  var files = Core__Option.getOr(Core__Option.map(match.files, (function (param) {
              return Core__Array.filterMap(param.edges, (function (edge) {
                            return Core__Option.map(edge, (function (edge) {
                                          return edge.node;
                                        }));
                          }));
            })), []);
  return files.map(function (file) {
              return JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsxs(ViewStack.make, {
                                      space: "xs",
                                      alignItems: "center",
                                      flexDirection: "row",
                                      children: [
                                        JsxRuntime.jsx(Icon__Jsx3.make, {
                                              icon: "File",
                                              size: 20,
                                              color: Theme__Color.mineShaft
                                            }),
                                        JsxRuntime.jsx(Text__Jsx3.make, {
                                              fontWeight: "bold",
                                              color: Colors.mineShaft,
                                              className: "truncate",
                                              children: file.fileName
                                            })
                                      ]
                                    }),
                                className: "block no-underline",
                                download: file.fileName,
                                href: Utils.baseAttachmentUrl(file.key),
                                target: "_blank"
                              }),
                          className: "max-w-[60vw] sm:max-w-[400px] bg-zinc-200 hover:bg-zinc-300 px-2.5 py-1.5 rounded transition-colors duration-150"
                        }, file.key);
            });
}

var WithoutErrorBoundary = {
  make: Conversation__MessageFiles$WithoutErrorBoundary
};

function Conversation__MessageFiles(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "attached files",
              children: JsxRuntime.jsx(Conversation__MessageFiles$WithoutErrorBoundary, {
                    message: props.message
                  })
            });
}

var make = Conversation__MessageFiles;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Utils Not a pure module */
